import { HttpClient, HttpHeaders } from "@angular/common/http";
import { GenericRepository } from "./generic-repository";
import { EventEmitter, Injectable, Output } from "@angular/core";
import { ConfigModel } from "../services/config/models/config.model";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { SsoService } from "../services/sso/sso.service";

@Injectable({
  providedIn: 'root'
})
export class ConfigRepository {
  @Output() public newMovilEmiter: EventEmitter<void> = new EventEmitter();

  public constructor(
    private http: HttpClient,
    private ssoService: SsoService
  ) {
  }

  public onSendConfig(): void {
    this.newMovilEmiter.emit();
  }

  public getConfig(): EventEmitter<void> {
    return this.newMovilEmiter;
  }

  private get(key: string, defValue: string): Observable<string> {
    const url = `${this.ssoService.getTicket().UrlApi}/api/config/get/${key}`;
    return this.http.get<ConfigModel[]>(url).pipe(
      map(result => (result && result.length && result[0].Valor) ? result[0].Valor : defValue),
      catchError(error => {
        console.error(error);
        return of(defValue);
      })
    );
  }

  private set(key: string, value: string): Observable<boolean> {
    const url = `${this.ssoService.getTicket().UrlApi}/api/config/set`;
    const body = { Clave: key, Valor: value };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'json'
      })
    };

    return this.http.post<boolean>(url, JSON.stringify(body), httpOptions).pipe(
      catchError(error => {
        console.error(error);
        return of(false);
      })
    );
  }

  public getUsuEmpApp(key: string, defValue: string): Observable<string> {
    const ticket = this.ssoService.getTicket();
    const composedKey = `${ticket.Usuario.Id}-${ticket.Empresa.Id}-${ticket.Aplicacion.Id}-${key}`;
    return this.get(composedKey, defValue);
  }

  public setUsuEmpApp(key: string, value: string): Observable<boolean> {
    const ticket = this.ssoService.getTicket();
    const composedKey = `${ticket.Usuario.Id}-${ticket.Empresa.Id}-${ticket.Aplicacion.Id}-${key}`;
    return this.set(composedKey, value);
  }

  public getEmpApp(key: string, defValue: string): Observable<string> {
    const ticket = this.ssoService.getTicket();
    const composedKey = `${ticket.Empresa.Id}-${ticket.Aplicacion.Id}-${key}`;
    return this.get(composedKey, defValue);
  }

  public setEmpApp(key: string, value: string): Observable<boolean> {
    const ticket = this.ssoService.getTicket();
    const composedKey = `${ticket.Empresa.Id}-${ticket.Aplicacion.Id}-${key}`;
    return this.set(composedKey, value);
  }

  public getEmp(key: string, defValue: string): Observable<string> {
    const ticket = this.ssoService.getTicket();
    const composedKey = `${ticket.Empresa.Id}-${key}`;
    return this.get(composedKey, defValue);
  }

  public setEmp(key: string, value: string): Observable<boolean> {
    const ticket = this.ssoService.getTicket();
    const composedKey = `${ticket.Empresa.Id}-${key}`;
    return this.set(composedKey, value);
  }
}
